<template>
  <div class="container-xl">
    <Card title="Agrupadores de evento" subtitle="Os grupos de evento são usados no portal de vendas para criar uma melhor experiência de navegação">
      <table class="table table-sm table-hover table-striped">
        <thead>
          <tr>
            <PkHeader/>
            <EditHeader/>
            <DeleteHeader/>
            <StatusHeader/>
            <th data-column-id="name">Nome</th>
          </tr>
        </thead>
      </table>
    </Card>
  </div>
</template>

<script>
import $ from 'jquery'
import { initGrid } from 'hennig-common'
import PkHeader from '@/components/grid/PkHeader'
import EditHeader from '@/components/grid/EditHeader'
import DeleteHeader from '@/components/grid/DeleteHeader'
import StatusHeader from '@/components/grid/StatusHeader'
import Card from '@/components/Card'

export default {
  name: 'EventGroups',
  components: {
    Card,
    StatusHeader,
    DeleteHeader,
    EditHeader,
    PkHeader
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      const addLabel = 'Adicionar'
      const collectionObj = 'EventGroup'
      initGrid({
        container: $(this.$el).find('table'),
        collectionObj,
        addLabel
      })
    }
  }
}
</script>
